export const generateTextStyles = (styles = {}, field, device = 'desktop') => {
  const css = {};
  for (const [suffix, property] of [['Font','fontFamily'], ['Weight','fontWeight'], ['Color','color'], ['Align','textAlign']]) {
    const value = styles?.[field + suffix];
    if (value && value !== 'inherit') css[property] = value;
  }
  for (const suffix of ['MarginTop', 'MarginBottom']) {
    const value = styles?.[field + suffix];
    if (value !== '' && value != null && Number.isFinite(Number(value))) css[suffix[0].toLowerCase() + suffix.slice(1)] = Number(value) + 'px';
  }
  const height = styles?.[field + 'LineHeight'];
  if (height && Number(height) > 0) css.lineHeight = String(height);
  const size = styles?.[field + 'Size'] || {};
  const selected = device === 'mobile' ? size.mobile || size.tablet || size.desktop : device === 'tablet' ? size.tablet || size.desktop : size.desktop;
  if (selected) css.fontSize = selected;
  const shadow = styles?.[field + 'Shadow'];
  if (shadow?.enabled) css.textShadow = `${shadow.x ?? 2}px ${shadow.y ?? 2}px ${shadow.blur ?? 4}px ${shadowColor(shadow)}`;
  else if (shadow) css.textShadow = 'none';
  return css;
};

const shadowColor = shadow => {
  const hex = (shadow.color || '#000000').replace('#', '');
  const expanded = hex.length === 3 ? hex.split('').map(c => c + c).join('') : hex;
  const alpha = Math.max(0, Math.min(100, Number(shadow.opacity ?? 60))) / 100;
  return /^[a-f\d]{6}$/i.test(expanded) ? `rgba(${[0,2,4].map(i => parseInt(expanded.slice(i,i+2),16)).join(',')},${alpha})` : shadow.color;
};

export const generateLogoShadow = (styles = {}) => styles.logoShadow?.enabled ? { filter: `drop-shadow(${styles.logoShadow.x ?? 2}px ${styles.logoShadow.y ?? 2}px ${styles.logoShadow.blur ?? 4}px ${shadowColor(styles.logoShadow)})` } : {};